import { useId, useState } from "react";

type Props = {
  label: string;
  value: string;
  onChange: (value: string) => void;
  autoComplete: string;
  required?: boolean;
};

export function PasswordField({ label, value, onChange, autoComplete, required }: Props) {
  const [show, setShow] = useState(false);
  const id = useId();
  const inputId = `${id}-input`;
  const toggleId = `${id}-show`;

  return (
    <div className="password-field">
      <label htmlFor={inputId}>
        {label}
        <input
          id={inputId}
          type={show ? "text" : "password"}
          autoComplete={autoComplete}
          value={value}
          onChange={(e) => onChange(e.currentTarget.value)}
          required={required}
        />
      </label>
      <div className="checkbox-row">
        <input
          id={toggleId}
          type="checkbox"
          checked={show}
          onChange={(e) => setShow(e.currentTarget.checked)}
        />
        <label htmlFor={toggleId} className="checkbox-label">
          Show password
        </label>
      </div>
    </div>
  );
}
